import './jsx/router';
import { unregister } from './registerServiceWorker';
import { defineCustomElements } from "@duetds/date-picker/dist/loader";

defineCustomElements(window);
unregister();
